import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SupportService } from 'src/app/services/core/support/support.service';
import { sweetAlert } from 'src/app/utils/swal';
@UntilDestroy()

// profile of the company, driver or vehicle a ticket is about, laid out like the driver profile of onecalltms
@Component({
  selector: 'app-support-reference-detail',
  templateUrl: './support-reference-detail.component.html',
  styleUrls: ['./support-reference-detail.component.css']
})
export class SupportReferenceDetailComponent implements OnInit {
  @Input() reference: any;
  @Output() closeModal = new EventEmitter<void>();

  profile: any;
  // the details in two columns
  detailColumns: any[] = [];

  constructor(private supportService: SupportService) { }

  ngOnInit() {
    this.supportService.getReferenceDetails(this.reference.type, this.reference.id)
      .pipe(untilDestroyed(this))
      .subscribe((data: any) => {
        this.profile = data;
        const half = Math.ceil(data.details.length / 2);
        this.detailColumns = [data.details.slice(0, half), data.details.slice(half)];
      }, (err) => {
        sweetAlert('Error', err, 'error', 'OK');
      });
  }
}
